module.exports = __webpack_public_path__ + "static/solution-section-monitoring-tab-2fa85c36eb08de465f00a46f943cbfb9.webp";